// src/components/OptionsForm.js
import React from 'react';

const OptionsForm = ({ setOptions }) => {
  const handleOptionChange = (e) => {
    const { name, value, checked } = e.target;
    setOptions(prevOptions => ({
      ...prevOptions,
      [name]: checked ? value : null,
    }));
  };

  return (
    <div className="options-form">
      <h2 className="options-form-title">Additional Options</h2>
      <div className="option-group">
        <label className="option-label">
          <input
            type="checkbox"
            className="option-checkbox"
            name="installation"
            value="50"  // Example cost for installation
            onChange={handleOptionChange}
          />
          Installation (+$50)
        </label>
      </div>
      <div className="option-group">
        <label className="option-label">
          <input
            type="checkbox"
            className="option-checkbox"
            name="transport"
            value="30"  // Example cost for transport
            onChange={handleOptionChange}
          />
          Transport (+$30)
        </label>
      </div>
    </div>
  );
};

export default OptionsForm;